module.exports = __webpack_public_path__ + "img/s1.4b7f3fc1.jpg";